var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-the-g01-content"},[_c('div',{staticClass:"p-the-g01-content__button_list"},[_c('G01ContentButtonList',{attrs:{"categories":_vm.categories,"is-category":_vm.isCategory}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }